import React from "react";

const NotFoundPage = () => {
  return null;
};

export { NotFoundPage };
